//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MtInput from "../form/MtInput";
import Button from "../other/Button";
import MtCheckbox from "../form/MtCheckbox";
import { checkAllValues } from '~/utils/utils';

export default {
  components: {
    MtInput,
    Button,
    MtCheckbox
  },
  props: {
    mirSelected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      policyChecked: false,
      policyError: false,
      inputValues: {
        name: '',
        surname: '',
        email: '',
        password: '',
      },
      validateValues: {
        name: false,
        surname: false,
        email: false,
        password: false,
      },
      formError: null,
      showHint: false,
      hintText: '',
    }
  },
  computed: {
    checkAllValues() {
      return checkAllValues(this.validateValues)
    }
  },
  methods: {
    submitForm() {
      const { name, surname, email, password } = this.inputValues
      this.policyError = false
      this.formError = null

      if(!this.policyChecked) {
        this.policyError = true
        return
      }

      if(!this.checkAllValues) {
        this.formError = 'Заполните все поля'
        return
      }

      this.$axios({
        method: 'post',
        url: '/api/register/',
        data: `lang=${this.$i18n.locale || 'ru'}&email=${email}&password=${password}&name=${name[0].toUpperCase() + name.slice(1)}&surname=${surname[0].toUpperCase() + surname.slice(1)}`
      })
        .then(({data}) => {
          if (data.error) {
            this.formError = data.error.message
            if(data.error.hint) {
              this.showHint = true
              this.hintText = data.error.hint
            } else {
              this.showHint = false
              this.hintText = ''
            }
          } else {
            this.$cookies.set('token', data.data.token)
            if (this.$store.getters['sidebars/getLoginAside']) {
              this.$store.commit('sidebars/loginAsideClose')
            }
            this.$store.commit('forms/changeRegistrationPopup')

            if (this.mirSelected) {
              this.$store.commit('openIframe')
            } else {
              window.location.href = '/app/profile/detail'
            }
          }
        })
        .catch(err => {
          console.log('ERORRRR', err)
        })
    }
  }
}
